(function () {
  'use strict';

  function qs(scope, sel) { return (scope || document).querySelector(sel); }
  function qsa(scope, sel) { return Array.from((scope || document).querySelectorAll(sel)); }

  function bufferedItems(grid) {
  return qsa(grid, 'li.grid__item[hidden]');
  }

  function revealBuffered(grid, count) {
    const items = bufferedItems(grid).slice(0, count);

    items.forEach((item) => {
      item.hidden = false;
      item.classList.remove('load-more__buffer-item');
    });

    return items.length;
  }

  const STATE = new WeakMap(); // container -> { nextUrl, loading }

  async function fetchAndAppend(container) {
    const state = STATE.get(container);

    if (!state || state.loading) return;

    const sectionId = container.getAttribute('data-section-id');
    const btn = qs(container, '.load-more__button');
    const spinner = qs(container, '.load-more__spinner');
    const grid = document.querySelector(
      `ul#product-grid[data-id="${sectionId}"]`
    );

    if (!grid) return;

    state.loading = true;

    if (btn) btn.disabled = true;
    if (spinner) spinner.classList.remove('visually-hidden');

    try {
      let remaining = state.batchSize;

      // 先に、現在のHTML内にある非表示商品を表示
      const revealedCount = revealBuffered(grid, remaining);
      remaining -= revealedCount;

      // 非表示商品だけでは不足する場合、次ページを取得
      while (remaining > 0 && state.nextUrl) {
        const res = await fetch(state.nextUrl, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const nextGrid = doc.querySelector(
          `ul#product-grid[data-id="${sectionId}"]`
        );

        const nextLoadMore = doc.querySelector(
          `.load-more[data-section-id="${sectionId}"]`
        );

        if (!nextGrid) {
          state.nextUrl = null;
          container.removeAttribute('data-next-url');
          break;
        }

        const items = qsa(nextGrid, 'li.grid__item');
        const frag = document.createDocumentFragment();

        // 取得商品はいったん非表示で追加
        items.forEach((item) => {
          item.hidden = true;
          item.classList.add('load-more__buffer-item');
          frag.appendChild(item);
        });

        grid.appendChild(frag);

        // 次の取得先を更新
        const newNextUrl = nextLoadMore
          ? nextLoadMore.getAttribute('data-next-url')
          : null;

        state.nextUrl = newNextUrl;

        if (newNextUrl) {
          container.setAttribute('data-next-url', newNextUrl);
        } else {
          container.removeAttribute('data-next-url');
        }

        // 今回の追加表示数に達するまで表示
        const newlyRevealed = revealBuffered(grid, remaining);
        remaining -= newlyRevealed;

        // 商品も次ページもない場合の無限ループ防止
        if (items.length === 0) {
          state.nextUrl = null;
          break;
        }
      }

      const hasBufferedItems = bufferedItems(grid).length > 0;
      const hasNextPage = Boolean(state.nextUrl);

      if (!hasBufferedItems && !hasNextPage) {
        teardownObserver(container);
        container.remove();
      } else if (btn) {
        btn.disabled = false;
      }
    } catch (e) {
      console.error('[LoadMore] fetch error', e);

      if (btn) btn.disabled = false;
    } finally {
      state.loading = false;

      if (spinner) {
        spinner.classList.add('visually-hidden');
      }
    }
  }

function setup(container) {
  const nextUrl = container.getAttribute('data-next-url');

  const batchSize =
    parseInt(container.getAttribute('data-batch-size'), 10) || 9;

  STATE.set(container, {
    nextUrl,
    batchSize,
    loading: false
  });

    const btn = qs(container, '.load-more__button');
    if (btn) btn.addEventListener('click', () => fetchAndAppend(container));

    const sentinel = qs(container, '.load-more__sentinel');
    if (!sentinel || !('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) fetchAndAppend(container);
      });
    }, {
      root: null,
      rootMargin: '0px 0px 400px 0px', // D=400px
      threshold: 0.01
    });

    io.observe(sentinel);
    container._loadMoreIO = io;
  }

  function teardownObserver(container) {
    if (container && container._loadMoreIO) {
      try { container._loadMoreIO.disconnect(); } catch {}
      delete container._loadMoreIO;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    qsa(document, '.load-more').forEach(setup);
  });

  // テーマエディタなどでセクション再描画時
  document.addEventListener('shopify:section:load', (e) => {
    qsa(e.target, '.load-more').forEach(setup);
  });
})();
